import React from "react";

import { Box, Grid, Typography, useTheme } from "@material-ui/core";
import CarouselOptionsService from "@components/CarouselOptionsService";
import CardOption from "@components/CardOption";

import ROUTES from "../../../config/routes";

import cardNovoPedidoImg from "../../../assets/card_novo_pedido.png";
import cardPedidosImg from "../../../assets/card_pedidos.png";
import cardTitulosImg from "../../../assets/card_titulos.png";
import cardNotasImg from "../../../assets/card_notas.png";

import useStylesHome from "./home.styles";

const services = [
  {
    image: cardNovoPedidoImg,
    title: "Novo Pedido",
    description: "Faça um novo pedido agora mesmo",
    link: ROUTES.USER_ROUTES.NEW_ORDER,
  },
  {
    image: cardPedidosImg,
    title: "Seus pedidos",
    description: "Acompanhe todos os seus pedidos já realizados.",
    link: ROUTES.USER_ROUTES.MY_ORDERS,
  },
  {
    image: cardTitulosImg,
    title: "Consultar títulos",
    description: "Consulte as vias dos seus boletos que estão em aberto.",
    link: ROUTES.USER_ROUTES.APPOINTMENT_TITLE,
  },
  {
    image: cardNotasImg,
    title: "Consultar notas fiscais",
    description: "Veja as suas notas fiscais.",
    link: ROUTES.USER_ROUTES.APPOINTMENT_INVOICES,
  },
];

interface HomeHeaderProps {
  isMobile: boolean;
  classes: ReturnType<typeof useStylesHome>;
}

const HomeHeader: React.FC<HomeHeaderProps> = (props) => {
  const { isMobile, classes } = props;
  const theme = useTheme();

  if (isMobile) {
    return (
      <Grid container style={{ width: "auto", margin: 14 }}>
        <Grid item xs={12}>
          <Typography
            style={{
              opacity: 0.6,
              fontSize: "1.2rem",
              fontWeight: 400,
              color: theme.palette.text.secondary,
            }}
          >
            Bem vindo ao
          </Typography>
          <Typography
            style={{
              fontSize: "2rem",
              fontWeight: 700,
              color: theme.palette.text.primary,
            }}
          >
            Portal do revendedor
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <CarouselOptionsService items={services} />
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Box className={classes.containerTitle}>
        <Typography variant="h5" className={classes.title}>
          PORTAL DO REVENDEDOR
        </Typography>
      </Box>
      <Box className={classes.containerOptions}>
        {services.map((value, index) => (
          <CardOption
            key={index}
            image={value.image}
            title={value.title}
            description={value.description}
            link={value.link}
          />
        ))}
      </Box>
    </>
  );
};

export default HomeHeader;
